import { render, staticRenderFns } from "./IndustryEvent.vue?vue&type=template&id=7c9b5d34&"
import script from "./IndustryEvent.vue?vue&type=script&lang=js&"
export * from "./IndustryEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports